import axios from "axios";
import GPSConfig from "./gps-config";
import toast from "react-hot-toast";

const gpsInstance = axios.create({
  baseURL: GPSConfig.api_baseurl,
  timeout: 10000, // Set a timeout limit for requests
  headers: GPSConfig.headers,
});

gpsInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Token"] = `${token}`;
    }
    return config;
  },
  (error) => {
    toast.error("Request failed. Please try again.");
  }
);

gpsInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          localStorage.clear();
          break;
        case 403:
          data?.responseMessage?toast.error(data?.responseMessage):toast.error("Forbidden access. You don't have permission.");
          break;
        case 404:
          data?.responseMessage?toast.error(data?.responseMessage):toast.error("Resource not found.");
          break;
        case 500:
          data?.responseMessage?toast.error(data?.responseMessage):toast.error("Internal server error. Please try again later.");
          
          break;
        default:
      }

      return error.response;
    } else if (error.request) {
      toast.error("No response from the server. Please check your connection.");  
      return error.request
    } else {
      toast.error("Request failed. Please try again.");
    }
  }
);

export default gpsInstance;

